import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "subscript-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.25 4.25012C2.25 3.83591 2.58579 3.50012 3 3.50012H15C15.4142 3.50012 15.75 3.83591 15.75 4.25012C15.75 4.66434 15.4142 5.00012 15 5.00012H9.7525V16.2501C9.7525 16.6643 9.41672 17.0001 9.0025 17.0001C8.58829 17.0001 8.2525 16.6643 8.2525 16.2501V5.00012H3C2.58579 5.00012 2.25 4.66434 2.25 4.25012Z" }, null, -1),
    _createElementVNode("path", { d: "M19.2864 14.0572C19.5667 14.1732 19.7495 14.4467 19.7495 14.7501V19.0023H20.245C20.6592 19.0023 20.995 19.338 20.995 19.7523C20.995 20.1665 20.6592 20.5023 20.245 20.5023H17.754C17.3398 20.5023 17.004 20.1665 17.004 19.7523C17.004 19.338 17.3398 19.0023 17.754 19.0023H18.2495V16.5601C17.9551 16.8235 17.5028 16.8139 17.2199 16.5312C16.9269 16.2384 16.9267 15.7636 17.2195 15.4705L18.469 14.22C18.6834 14.0054 19.0061 13.9411 19.2864 14.0572Z" }, null, -1)
  ])))
}
export default { render: render }